// extracted by mini-css-extract-plugin
module.exports = {"UserScreenContent":"UserScreenSection_UserScreenContent__3Ydqd","UserScreenContentTitle":"UserScreenSection_UserScreenContentTitle__2tua1"};